import styled from 'styled-components';

const StyledRadioGroupWrapper = styled.div `
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export { StyledRadioGroupWrapper };
//# sourceMappingURL=RadioGroup.styles.js.map
